import Http from '@/api/http.js'

export default {

  index() {
    // let search = ''
    // const {limit, page, level} = filter
    // search = `_page=${page}&_limit=${limit || 1000}&attributes.level=${level}`

    return Http.get(`/remote_addresses`)
  },

  indexByModel({model, id}) {
    return Http.get(`${model}/${id}/remote_addresses`)
  },

  create(address){
    return Http.post(`/remote_addresses`, {address: {...address}})
  },

  update(address){
    return Http.put(`/remote_addresses/${address.id}`, {
      address: {...address},
    });
  },

  show(id) {
    return Http.get(`/remote_addresses/${id}`);
  },

  delete(id){
    return Http.delete(`/remote_addresses/${id}`)
  }

}
